"use strict";

var _Icon, _Text;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { PhoneFlatIcon } from '@autoguru/icons';
import { Box, Icon, Text, useMedia } from '@autoguru/overdrive';
import { useState } from 'react';
import { SupportHeaderModal } from './SupportHeaderModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const SupportHeader = () => {
  const [isDesktop] = useMedia(['desktop'], false);
  const [showModal, setShowModal] = useState(false);
  const changeState = () => {
    setShowModal(!showModal);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      as: "a",
      borderWidthLeft: isDesktop ? '1' : 'none',
      borderColour: "light",
      display: "flex",
      onClick: () => changeState(),
      children: [/*#__PURE__*/_jsx(Box, {
        marginRight: isDesktop ? '3' : 'none',
        paddingLeft: isDesktop ? '4' : 'none',
        children: _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
          size: "medium",
          icon: PhoneFlatIcon
        }))
      }), isDesktop ? _Text || (_Text = /*#__PURE__*/_jsx(Text, {
        colour: "dark",
        children: "Support"
      })) : void 0]
    }), /*#__PURE__*/_jsx(SupportHeaderModal, {
      showModal: showModal,
      changeState: changeState
    })]
  });
};